var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.state),expression:"state"}],staticClass:"loading"},[_vm._v(_vm._s(_vm.$t('text')))])}
var staticRenderFns = []

export { render, staticRenderFns }